<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container d-flex flex-nowrap justify-content-between">
        <span class="navbar-brand"><span class="text-primary">Cake</span>Timer</span>

        <div class="row no-gutters">
          <div v-if="isStatus(['stopped', 'finished'])" class="col">
            <input
              ref="timeInput"
              type="text" 
              v-model="timeInput" 
              class="form-control w-100" 
              placeholder="Zeit in Min. (1 - 1440)"
              :disabled="isStatus(['running', 'paused'])" 
              @keyup.enter="startTimer()"
              autofocus>
          </div>
          <div v-if="timeInput" class="col col-auto text-right">
            <button v-if="isStatus(['stopped', 'finished'])" @click="startTimer()" type="button" class="btn btn-primary ml-2">Start</button>
            <button v-if="isStatus('paused')" @click="continueTimer()" type="button" class="btn btn-success mr-2">Weiter</button>
            <button v-if="isStatus('running')" @click="pauseTimer()" type="button" class="btn btn-secondary mr-2">Pause</button>
            <button v-if="isStatus(['running', 'paused'])" @click="stopTimer()" type="button" class="btn btn-danger">Stop</button>
          </div>
        </div>
      </div>
    </nav>
    <div class="container mt-3">
      
      <div v-if="isStatus(['running', 'paused'])">
        <div class="text-center my-4" :style="{ opacity: timeActual == timeInit ? 0 : 1 }">
          <h1 :class="{ 'text-danger': timeActual < 30 }">{{ humanReadableTime(timeActual) }}</h1>
        </div>
        <canvas ref="canvas" width="250px" height="250px" class="d-block mx-auto my-4"></canvas>
      </div>
      <div v-else-if="isStatus('finished')" class="text-center text-primary py-5 h2">
        Zeit ist um!
        <div class="mt-4">
          <img src="./assets/button-smiley.png" style="width: 250px;">
        </div>
      </div>
      <div v-else class="text-center py-2 text-muted">
        <p style="font-size: 1.2em;">Gib die Anzahl Minuten im Feld oben rechts ein um einen Timer zu starten.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      timeInput: '',
      timeInit: null,
      timeActual: null,
      timer: null,
      timerStatus: 'stopped',
      timerStartTime: null,
      canvas: null,
      ctx: null,
    }
  },

  updated() {
    if(this.isStatus('running')) {
      if(this.timeActual >= 60) {
        this.drawCircle(360 / this.timeInit * this.timeActual);
      } else {
        this.drawCircle(360 / 60 * this.timeActual);
      }
    }
  },

  mounted() {
    this.$refs.timeInput.focus();
  },

  methods: {
    startTimer() {
      if(isNaN(this.timeInput)) {
        alert('Nur Zahlen erlaubt!')
        return null;
      }

      if(this.timeInput < 1) {
        this.timeInput = 1;
      } else if (this.timeInput > 1440) {
        this.timeInput = 1440;
      }

      this.timeInit = this.timeInput * 60;
      this.timeActual = this.timeInit;
      this.timerStartTime = new Date().getTime() / 1000;

      this.timerStatus = 'running';
      this.timer = setInterval(this.runClock, 1000);
    },

    continueTimer() {
      this.timerStatus = 'running';
      this.timer = setInterval(this.runClock, 1000);
    },

    pauseTimer() {
      this.timerStatus = 'paused';
      clearInterval(this.timer);
    },

    stopTimer() {
      this.pauseTimer();
      this.timerStatus = 'stopped';
      this.timer = null;
      this.timeActual = this.timeInit;
    },

    finishTimer() {
      this.stopTimer();
      this.timerStatus = 'finished';
    },

    runClock() {
      // let timeDiff = parseInt((new Date().getTime() / 1000) - this.timerStartTime);
      // this.timeActual = this.timeInit - timeDiff;

      this.timeActual--;
      
      if(this.timeActual <= 0) {
        this.finishTimer();
      }
    },

    drawCircle(deg) {
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext('2d');
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      // Draw outer circle
      this.ctx.fillStyle = '#cde2fe';
      this.ctx.beginPath();
      this.ctx.moveTo(this.canvas.width / 2, this.canvas.height / 2);
      this.ctx.arc(this.canvas.width / 2, this.canvas.height / 2, this.canvas.width / 2, this.degToRad(0), this.degToRad(360));
      this.ctx.fill();


      // Draw portion
      this.ctx.fillStyle = '#167ffb';
      this.ctx.beginPath();
      this.ctx.moveTo(this.canvas.width / 2, this.canvas.height / 2);
      this.ctx.arc(this.canvas.width / 2, this.canvas.height / 2, this.canvas.width / 2, this.degToRad(-90), this.degToRad(deg - 90));
      this.ctx.lineTo(this.canvas.width / 2, this.canvas.height / 2);
      this.ctx.fill();
    },

    degToRad(deg) {
      return (Math.PI / 180) * deg;
    },

    humanReadableTime(seconds) {
      if(!seconds) {
        return '';
      }

      if(seconds >= 3600) {
        let hours = parseInt(seconds / 3600);
        let minutes = (seconds - (3600 * hours)) / 60;
        return `${hours}h ${parseInt(minutes)}'`;
      }

      if(seconds >= 60) {
        return `${parseInt(seconds / 60) + 1}'`;
      }

      return `${seconds}''`;
    },
    
    isStatus(statusArr) {
      if(typeof statusArr === 'string') {
        return this.timerStatus == statusArr;
      }

      return statusArr.indexOf(this.timerStatus) !== -1;
    }
  },
}
</script>

<style lang="scss">
  $font-family-sans-serif: 'Rubik', sans-serif;
  $primary: #ffa500;

  @import "~bootstrap/scss/bootstrap";

  h1 {
    font-size: 4rem;
  }
</style>
